import { Auth } from 'aws-amplify';

const authMixin = {

  data() {
    return {
      currentUser: null,
    };
  },

  methods: {
    async isLoggedIn() {
      try {
        this.currentUser = await Auth.currentAuthenticatedUser();
        return true;
      } catch (err) {
        return false;
      }
    },
  },

  async mounted() {
    const loggedIn = await this.isLoggedIn();
    const paths = ['SignUp', 'SignIn', 'ForgotPassword'];
    if (loggedIn && paths.indexOf(this.$route.name) !== -1) {
      this.$router.push({ path: '/' });
    }
  },
};

export default authMixin;
